function renderPopulateListRelsFunctionResultTemplate({
  v,
  qListFieldName,
  qRelFieldName,
  qRelTable
}: {
  v: string
  qListFieldName: string
  qRelFieldName: string
  qRelTable: string
}): string {
  return `  const ${v}Ids = record.${qListFieldName} && Array.isArray(record.${qListFieldName})
    ? (record.${qListFieldName} as Record<string, unknown>[])
        .map((item) => item.${qRelFieldName})
        .filter((id) => id != null && id !== '')
        .map((id) => String(id))
    : []

  const ${v}Results = ${v}Ids.length > 0
    ? await db.select().from(${qRelTable}).where(inArray(${qRelTable}.id, ${v}Ids))
    : []

  const ${v}Map = new Map(${v}Results.map((r) => [r.id, r]))

  if (record.${qListFieldName} && Array.isArray(record.${qListFieldName})) {
    record.${qListFieldName} = (record.${qListFieldName} as Record<string, unknown>[]).map((item) => {
      const relId = item.${qRelFieldName} ? String(item.${qRelFieldName}) : null
      return {
        ...item,
        ${qRelFieldName}: relId ? ${v}Map.get(relId) || null : null
      }
    })
  }`
}

function renderPopulateListRelsFunctionContentTemplate({
  singular,
  join
}: {
  singular: string
  join: string
}): string {
  return `
async function populate${singular}ListRelationships(record: ${singular}): Promise<${singular}> {
${join}

  return record
}
`
}

export function renderPopulateListRelsFunctionRenderer(
  request:
    | {
        kind: 'renderPopulateListRelsFunctionResultTemplate'
        props: {
          v: string
          qListFieldName: string
          qRelFieldName: string
          qRelTable: string
        }
      }
    | {
        kind: 'renderPopulateListRelsFunctionContentTemplate'
        props: {
          singular: string
          join: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderPopulateListRelsFunctionResultTemplate':
      return renderPopulateListRelsFunctionResultTemplate(request.props)
    case 'renderPopulateListRelsFunctionContentTemplate':
      return renderPopulateListRelsFunctionContentTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
